<u-list-box
  *ngIf="versionListViewModel()?.length > 0"
  [items]="versionListViewModel()"
  [selectedItem]="selectedCardVersion()"
  [itemTemplate]="versionTemplate"
  (selectedChange)="selectedVersion($event?.index)"
  [listStyle]="{ 'max-height': 'calc(90vh - 51px) ', width: '260px' }"
  [filter]="false"
  [selectOnFocus]="true"
  tabindex="0"
>
  <ng-template #versionTemplate let-version let-index="index">
    <div class="version-item">
      <avatar [size]="'24px'" [url]="version?.icon"></avatar>
      <div class="version-details">
        <span class="updated-time"> {{ version?.updatedTime }} </span>
        <span class="current-version">
          @if (index == 0) {
            <span [ngClass]="{ verify: verificationStatus() === 'Verified', unverify: verificationStatus() === 'Unverified' }">
              Current:
              @if (verificationStatus()) {
                <u-icon [model]="verificationIcon()" [styles]="{ fontSize: '14px' }"></u-icon>
              }
            </span>
          }
          <span class="sub-text bold-text">{{
            versions().length - 1 !== index ? 'Revision #' + (version?.version || 0) : 'Original'
          }}</span>
        </span>
        <span
          class="sub-text truncate-text"
          [pTooltip]="version.modifiedBy.length > 28 ? version.modifiedBy : null"
          tooltipPosition="top"
          tooltipStyleClass="u-tooltip"
        >
          {{ version?.modifiedBy }}
        </span>
        @if (version?.versionChangeLog) {
          <span
            class="sub-text truncate-text version-changeLog-text"
            [pTooltip]="version.versionChangeLog.length > 18 ? version.versionChangeLog : null"
            tooltipPosition="top"
            tooltipStyleClass="u-tooltip"
          >
            <span class="bold-text">Notes:</span>
            {{ version.versionChangeLog }}
          </span>
        }
      </div>
    </div>
  </ng-template>
</u-list-box>
